import { newRequest } from "std/api/newRequest";

export type ApiUsuarioRotaMinhas = {
	usu_idpk: number;
	usu_nome: string;
	perfil: string;
	isAdmin: boolean;
	/** todas = admin; somente = só as rotas vinculadas a ele (sem vínculo = nenhuma). */
	acessoRotas: { tipo: "todas" } | { tipo: "somente"; ids: number[] };
};

export function apiUsuarioRotaMinhas(): Promise<ApiUsuarioRotaMinhas> {
	return newRequest({
		url: "UsuarioRota/Minhas",
		type: "get",
		showErrorNotification: false,
	});
}
